import * as R from 'ramda';

const normalizeEmail = R.pipe(R.defaultTo(''), String, R.toLower);

export const matchesStudent = (student) => (record) => {
  const studentIds = R.reject(R.isNil, [
    student.id,
    student._id,
    student.studentId,
  ]);
  const recordIds = R.reject(R.isNil, [
    record.studentId,
    record.student_id,
    record.student,
    record.userId,
    record.user_id,
  ]);
  const hasMatchingId = R.any((id) => R.includes(id, studentIds), recordIds);
  const studentEmail = normalizeEmail(student.email);
  const recordEmail = normalizeEmail(record.email);

  return hasMatchingId || (studentEmail && studentEmail === recordEmail);
};

export const findStudentSubmission = (student, quiz) =>
  R.find(matchesStudent(student), R.propOr([], 'submissions', quiz));

export const filterQuizForStudent = (student) => (quiz) => {
  const submission = findStudentSubmission(student, quiz);

  if (submission) {
    return {
      ...quiz,
      submissions: [submission],
      pending: [],
      expected: 1,
      student_score: submission.globalScore,
      student_submission: submission,
    };
  }

  return {
    ...quiz,
    submissions: [],
    pending: [
      {
        id: student.id,
        first_name: student.first_name,
        last_name: student.last_name,
        email: student.email,
      },
    ],
    expected: 1,
    student_score: null,
    student_submission: null,
  };
};
